import { render, staticRenderFns } from "./ProjectItem.vue?vue&type=template&id=99101fb2&lang=pug&"
import script from "./ProjectItem.vue?vue&type=script&lang=js&"
export * from "./ProjectItem.vue?vue&type=script&lang=js&"
import style0 from "./ProjectItem.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99101fb2')) {
      api.createRecord('99101fb2', component.options)
    } else {
      api.reload('99101fb2', component.options)
    }
    module.hot.accept("./ProjectItem.vue?vue&type=template&id=99101fb2&lang=pug&", function () {
      api.rerender('99101fb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/ProjectItem.vue"
export default component.exports